import axios from "axios";
import {
  OpenAPI,
  OrganizationHeaderVMSingleItemResponseVM,
} from "@propertelligent/client-api";

/**
 * Thin shim over GET /api/Contractor/organization-header-info — the contractor's own-organization
 * basic info (name / logo / contact phone / support email / address), resolved server-side from the
 * JWT contractor claim (no client-supplied org id).
 *
 * The generated @propertelligent/client-api (1.0.2170) does not yet expose
 * ContractorService.getApiContractorOrganizationHeaderInfo (the client is regenerated from the
 * backend Swagger on CI), so this calls the endpoint directly using the same OpenAPI base + token
 * the generated client uses. Mirrors the pattern in chatbot.service.ts — switch to the generated
 * ContractorService method once it is published.
 *
 * Contractors can no longer read the Organization entity directly (GET /api/Organization/{id} and
 * /header-info are now permissioned to org-admin / platform), so this propagation endpoint is the
 * sanctioned source of organization info for the contractor portal.
 *
 * Returns the standard response envelope so it can be passed straight to apiHelper, exactly like a
 * generated client method (apiHelper reads `.data.success`).
 */
export const getContractorOrganizationHeaderInfo =
  async (): Promise<OrganizationHeaderVMSingleItemResponseVM> => {
    const base = OpenAPI.BASE || "";
    const token = typeof OpenAPI.TOKEN === "string" ? OpenAPI.TOKEN : "";

    const res = await axios.get(
      `${base}/api/Contractor/organization-header-info`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return res.data as OrganizationHeaderVMSingleItemResponseVM;
  };
